import httpClient from '../utils/httpClient';

// AFTER (add access_code) add access code for the beta to make user beta enter code
export async function signUp({ email, firstName, lastName, password }) {
  const { data } = await httpClient.post('/api/auth/signup', {
    email, firstName, lastName, password
  });
  return data;
}

export async function verifySignUp({ email, code }) {
  const { data } = await httpClient.post('/api/auth/signup/verify', {
    email,
    code,
  });
  return data;
}

export async function login({ email, password }) {
  const { data } = await httpClient.post(
    '/api/auth/login',
    { email, password }
  );
  return data;
}

export async function requestPasswordReset(email) {
  await httpClient.post('/api/auth/forgot-password', { email });
  // server intentionally returns a generic success; no payload needed
  return true;
}

export const resetPassword = ({ userId, token, password }) =>
  httpClient.post('/api/auth/reset-password', {
    userId,
    token,
    newPassword: password,
  }).then(res => res.data);
  
export async function getCurrentUser() {
  const response = await httpClient.get('/api/user/me');
  return response.data;
}

export async function recordMyActivity() {
  await httpClient.post('/api/user/me/activity');
}

export async function getUserStreak() {
  const response = await httpClient.get('/api/user/me/streak');
  return response.data;
}

export async function submitUserFeedback({ category, message }) {
  const response = await httpClient.post('/api/user/me/feedback', {
    category,
    message,
    platform: 'web',
    appVersion: process.env.REACT_APP_VERSION || null,
  });
  return response.data?.feedback;
}

export async function deleteMyAccountHard({ acknowledgedBillingContinues = false } = {}) {
  await httpClient.delete('/api/auth/account', {
    data: { acknowledgedBillingContinues },
  });
}

export async function logout() {
  await httpClient.post('/api/auth/logout');
}

export async function getMyTrainingPlans({ page = 1, limit = 5 } = {}) {
  const res = await httpClient.get('/api/user/me/training-plans', {
    params: { page, limit },
  });
  return res.data; // { items, page, limit, total, pages, hasMore }
}

export async function getMyPracticeMeetings({ page = 1, limit = 5 } = {}) {
  const res = await httpClient.get('/api/user/me/practice-meetings', {
    params: { page, limit },
  });
  return res.data; // { items, page, limit, total, pages, hasMore }
}

export async function getUserOverview() {
  const  {data }  = await httpClient.get('/api/user/profile-overview')
  return data
}

//for the overview page
export const getUpcoming = (params = {}) =>
  httpClient.get('/api/user/me/upcoming', { params }).then(r => r.data);

export const getRecentActivity = (params = {}) =>
  httpClient.get('/api/user/me/recent-activity', { params }).then(r => r.data);

export async function getUserPracticeCoreMetrics() {
  const {data} = await httpClient.get('/api/user/practice-core-metrics');
  return data // match your httpClient shape
}
